module.exports = __webpack_public_path__ + "media/images/favicon-029fab93020a10ede7706db2c9b88ee9.png";